import { MINUTE, type SourceDefinition } from '../types';

export const config = {
  id: 'calendar',
  kind: 'external',
  refetchMiliseconds: MINUTE,
} satisfies SourceDefinition;
